import { textFormatEditor, generateColumn, renderNA } from './../../../../../utils/commonFunctions';
import type { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";

/**
 * Column definitions for listing page
 * cellRenderer to show data as a string
 * valueGetter for getting data from export functionality of ag-grid
 * filterValueGetter for getting data from filter
 * tooltipValueGetter for getting data from tooltip
 * textFormatEditor for getting data from text editor
 */
// nameColumn,
const columnDefs: ColDef[] = [idColumn,

  {
    field: "name",
    headerName: "Name",
    cellRenderer: (props: any) => {
      return renderNA(props.data.name);
    }
  },
  {
    ...generateColumn("", `certifications`),

    cellRenderer: (props: any) => {
      return renderNA(props.data?.[`certifications`]?.map((data: any) => { return data?.short_form })?.toString());
    },
    filterValueGetter: (props: any) => {
      return renderNA(props.data?.[`certifications`]?.map((data: any) => { return data?.short_form })?.toString());
    },
    tooltipValueGetter: (props: any) => {
      return renderNA(props.data?.[`certifications`]?.map((data: any) => { return data?.short_form })?.toString());
    },
    valueGetter: (props: any) => {
      return props.data?.[`certifications`]?.map((data: any) => { return data?.short_form })?.join("#");
    },
  },
  {
    ...generateColumn("", `industries`),

    cellRenderer: (props: any) => {
      return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
    },
    filterValueGetter: (props: any) => {
      return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
    },
    tooltipValueGetter: (props: any) => {
      return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
    },
    valueGetter: (props: any) => {
      return props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.join("#");
    },
  },
  {
    ...generateColumn("Youtube Video URL", "video_url"),
    tooltipValueGetter: (props: any) => {
      return renderNA(props?.data?.['video_url']);
    },
    filterValueGetter: (props: any) => {
      return renderNA(props?.data?.['video_url']);
    },
    valueGetter: (props: any) => {
      return props?.data?.['video_url'];
    },
  },

  {
    ...generateColumn("", "description"),
    ...textFormatEditor("description"),
  },
  {
    ...generateColumn("", "knowledge_skills"),
    ...textFormatEditor("knowledge_skills"),
  },
  {
    ...generateColumn("Education Training", "education_training"),
    ...textFormatEditor("education_training"),
  },
  {
    ...generateColumn("", "experience"),
    ...textFormatEditor("experience"),
  },
  {
    ...generateColumn("Credentialing Require Optional", "credentialing"),
    ...textFormatEditor("credentialing"),
  },
  // {
  //   ...generateColumn("Salary Range", "position_reports_to"),

  //   ...textFormatEditor("position_reports_to"),
  // },

  {
    ...generateColumn("", "career_path_moves_from_this_role"),
    ...textFormatEditor("career_path_moves_from_this_role"),
  },



  {
    ...generateColumn("Career Category", `categories`),

    cellRenderer: (props: any) => {
      return renderNA(props.data?.[`categories`]?.map((data: any) => { return data?.code })?.toString());
    },
    filterValueGetter: (props: any) => {
      return renderNA(props.data?.[`categories`]?.map((data: any) => { return data?.code })?.toString());
    },
    tooltipValueGetter: (props: any) => {
      return renderNA(props.data?.[`categories`]?.map((data: any) => { return data?.code })?.toString());
    },
    valueGetter: (props: any) => {
      return props.data?.[`categories`]?.map((data: any) => { return data?.code })?.join("#");
    },
  },
  {
    ...generateColumn("Career Category Description", "career_category_text"),
    ...textFormatEditor("career_category_text"),

  },

  {
    ...generateColumn("", "salary_start"),
    ...textFormatEditor("salary_start"),
    headerName: "Salary Start",

  },
  {
    ...generateColumn("", "salary_end"),
    ...textFormatEditor("salary_end"),
    headerName: "Salary End",
  },
  {
    field: "default_status",
    headerName: "Default Status",
    cellRenderer: (props: any) => {
      return renderNA(props.data.default_status);
    },
  },
  {
    field: "critical_status",
    headerName: "Critical Status",
    cellRenderer: (props: any) => {
      return renderNA(props.data.critical_status);
    },
  },
  {
    field: "career_group.name",
    headerName: "Career Group",
    cellRenderer: (props: any) => {
      return renderNA(props?.data?.career_group?.name);
    },
    filterValueGetter: (props: any) => {
      return renderNA(props?.data?.career_group?.name);
    },

  },
  {
    ...generateColumn("Career Level", "level"),
    cellRenderer: (props: any) => {
      return renderNA(props?.data?.level);
    },
  },
  statusColumn, actionColumn];
export default columnDefs;
